import React, { useCallback, useContext, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { IAppVersion } from 'store/VersioningStore';
import RootStore from 'store';
import Spinner from 'components/base/spinner';
import { LoadingStatus, UserRoles } from 'enums';
import VersionBlock from 'components/versioning/VersionBlock';
import { PLATFORMS } from 'components/versioning/constants';
import { Card } from 'primereact/card';
import { ToastContext } from 'App';
import userStore from 'store/UserStore';
import { Message } from 'primereact/message';

const VersioningPageComponent: React.FC<{ rootStore?: typeof RootStore }> = ({
  rootStore,
}) => {
  const { versioningStore } = rootStore!;
  const toast = useContext(ToastContext);
  const isReadOnly = userStore.role === UserRoles.SUPPORT;

  useEffect(() => {
    versioningStore.getAppVersions(toast);
  }, [versioningStore, toast]);

  const handleUpdateVersion = useCallback(
    (store: string, validVersion: string, outdatedVersion: string) => {
      versioningStore.updateAppVersion(
        store,
        validVersion,
        outdatedVersion,
        toast,
      );
    },
    [versioningStore, toast],
  );

  if (
    versioningStore.status === LoadingStatus.PENDING &&
    !versioningStore.versions.length
  ) {
    return <Spinner />;
  }

  return (
    <div>
      <h1>Версионирование МП</h1>
      {isReadOnly && (
        <Message
          severity="info"
          text="Доступно только для чтения"
          style={{ marginBottom: '1rem', width: '100%' }}
        />
      )}
      <Card>
        {PLATFORMS.map((platform) => (
          <VersionBlock
            key={platform}
            title={platform}
            versionData={versioningStore.versions.find(
              (v: IAppVersion) => v.store === platform,
            )}
            updateVersion={handleUpdateVersion}
            isLoading={versioningStore.status === LoadingStatus.PENDING}
            updatingStore={versioningStore.updatingStore}
            isReadOnly={isReadOnly}
          />
        ))}
      </Card>
    </div>
  );
};

const VersioningPage = inject('rootStore')(observer(VersioningPageComponent));
export { VersioningPage };
